import { useCallback, useEffect, useState } from "react";

/** Fired by the demo store after every change of the sample data. Screens that
 *  poll re-fetch on it so the demo feels instant; outside the demo the event
 *  never fires. */
export const DATA_CHANGED_EVENT = "ces:data-changed";

export function emitDataChanged(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(DATA_CHANGED_EVENT));
}

/** `callback` must be stable (useCallback) — it is the effect dependency. */
export function useDataChanged(callback: () => void): void {
  useEffect(() => {
    window.addEventListener(DATA_CHANGED_EVENT, callback);
    return () => window.removeEventListener(DATA_CHANGED_EVENT, callback);
  }, [callback]);
}

/** A counter that bumps on every demo data change — drop it into a loader
 *  effect's dependency array so the screen refetches while the demo runs. */
export function useDataChangedTick(): number {
  const [tick, setTick] = useState(0);
  useDataChanged(useCallback(() => setTick((n) => n + 1), []));
  return tick;
}
